const getActiveFlag = () => JSON.parse(window.localStorage.getItem("feature"));

export const setFeatureActive = (flag) => {
  if (!flag) {
    const prevFeatureFlag = window.localStorage.getItem("feature");
    return window.localStorage.setItem("feature", prevFeatureFlag);
  }
  const currentFlag = flag === "true";
  return window.localStorage.setItem("feature", currentFlag);
};

export const isFeatureActive = () => getActiveFlag();
